import { kadryDateTime, type KadryDelivery, type KadrySearchRun } from '@entities/kadry';

export const CHANNEL_TITLE: Record<string, string> = {
  hh: 'hh.ru',
  rabota: 'Работа.ру',
  telegram: 'Telegram',
  max: 'MAX',
  sms: 'SMS',
};

export const RESPONSE_CHANNEL: Record<string, string> = {
  web: 'по ссылке',
  telegram: 'Telegram',
  max: 'MAX',
  platform: 'сам откликнулся на вакансию',
};

export const SOURCE_TITLE: Record<string, string> = {
  hh: 'hh.ru',
  rabota: 'Работа.ру',
  internal: 'Резерв',
  avito: 'Авито',
  superjob: 'SuperJob',
};

export const DELIVERY_TEXT: Record<KadryDelivery['status'], string> = {
  sent: 'отправлено',
  queued: 'отправляется',
  failed: 'ошибка',
  unknown: 'проверить',
  skipped: 'не отправлялось',
};

/** Реестр кандидатов заявки: поиск, вакансия hh, предложения и ответы. */
export const VACANCY_UI = {
  hh: { title: 'hh.ru', placeholder: 'https://hh.ru/vacancy/123456' },
  rabota: { title: 'Работа.ру', placeholder: 'https://www.rabota.ru/vacancy/123456/' },
} as const;

/** Сортировки реестра заявки. */
export const SORTS = ['answer', 'fresh', 'waiting', 'score', 'experience', 'name'] as const;

export function deliveryTone(d: KadryDelivery): 'success' | 'warning' | 'danger' | 'info' | 'neutral' {
  switch (d.status) {
    case 'sent':
      return 'success';
    case 'queued':
      return 'info';
    case 'failed':
      return 'danger';
    case 'unknown':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function runLine(run: KadrySearchRun | undefined): string {
  if (!run) return 'Поиск ещё не запускался.';
  if (run.status === 'running') return 'Идёт поиск и анализ резюме…';
  const hh = run.report.sources?.find((s) => s.source === 'hh');
  const when = kadryDateTime(run.finished_at ?? run.started_at);
  if (run.status === 'failed') return `Поиск ${when} не удался: ${run.error ?? 'ошибка'}`;
  if (!hh) return `Последний поиск ${when}.`;
  if (hh.status === 'skipped') return `Последний поиск ${when}: hh.ru — ${hh.notes.join('; ')}`;
  const byModel = hh.analyzed_by_model > 0 ? `, DeepSeek — ${hh.analyzed_by_model}` : '';
  return `Последний поиск ${when}: на hh.ru найдено ${hh.found}, новых ${hh.new_candidates}, разобрано резюме ${hh.analyzed}${byModel}.`;
}
